import { LoggerSettings } from './Logger.js';
import { ConsoleLogger } from './console/ConsoleLogger.js';
const empty = (...args) => { };
const types = ['log', 'debug', 'info', 'warn', 'error'];
/**
 * Logging Service 🪵.
 */
export class LoggingService {
    constructor(category, rules) {
        this.category = category;
        this.rules = rules;
        this.log = empty;
        this.debug = empty;
        this.info = empty;
        this.warn = empty;
        this.error = empty;
        this.console_logger = new ConsoleLogger(category);
        this.setup();
    }
    update_methods() {
        if (!LoggerSettings.is_enabled) {
            this.set_empty_methods();
            return;
        }
        if (LoggerSettings.overrides) {
            const { only, exclude } = LoggerSettings.overrides;
            if ((only.size && !only.has(this.category)) || (exclude.size && exclude.has(this.category))) {
                this.set_empty_methods();
                return;
            }
        }
        const applicable_rules = this.rules.filter(rule => rule.categories.includes(this.category));
        types.forEach(type => {
            if (applicable_rules.length) {
                this[type] = applicable_rules.some(rule => types.indexOf(rule.type) <= types.indexOf(type)) ? this.console_logger[type] : empty;
            }
            else {
                this[type] = this.console_logger[type];
            }
        });
    }
    setup(rules) {
        if (rules) {
            this.rules = rules;
        }
        this.update_methods();
    }
    set_empty_methods() {
        types.forEach(type => {
            this[type] = empty;
        });
    }
}
//# sourceMappingURL=LoggingService.js.map